import React, { useState } from 'react';
import axios from 'axios';

const RestaurentMaster = () => {
    const [createRest, setCreateRest] = useState({
        Rest_Name: "",
        Status: "Active"
    });

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCreateRest(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle radio button changes
    const handleStatusChange = (e) => {
        setCreateRest(prevState => ({
            ...prevState,
            Status: e.target.value
        }));
    };

    // Handle form submission
    const createRestData = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_API}restaurants`, createRest);
            console.log("Restaurant Created Successfully", response.data);


            alert("Restaurant Created Successfully")
            // Clear the form after successful submission
            setCreateRest({
                Rest_Name: "",
                Status: "Active"
            });
        } catch (error) {
            console.log("Restaurant Create API error", error);
        }
    };

    return (
        <div className="container-fluid border p-3">
            <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        name="Rest_Name"
                        value={createRest.Rest_Name}
                        placeholder="Restaurant Name"
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12 col-md-6 col-lg-4 d-flex">
                    {/* Active Radio Button */}
                    <div className="form-check me-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="activeStatus"
                            name="Status"
                            value="Active"
                            checked={createRest.Status === "Active"}
                            onChange={handleStatusChange}
                        />
                        <label className="form-check-label" htmlFor="activeStatus">
                            Active
                        </label>
                    </div>

                    {/* In-Active Radio Button */}
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="inactiveStatus"
                            name="Status"
                            value="Inactive"
                            checked={createRest.Status === "Inactive"}
                            onChange={handleStatusChange}
                        />
                        <label className="form-check-label" htmlFor="inactiveStatus">
                            In-Active
                        </label>
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-12 col-md-6 col-lg-4 justify-content-center">
                    <button
                        className="btn btn-primary"
                        onClick={createRestData}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RestaurentMaster;
